<template>
  <div id="sections_nav" :class="[this.lang === 'ar' ? 'flex-row-reverse' : '', 'w-100 d-flex']"
    style="padding: 0 4vw; height: 70px; font-size: 15px" class="border-bottom-white-1-50" v-click-outside="closeSearch">
    <div :class="[this.lang === 'ar' ? 'flex-row-reverse' : '', 'flex-center']">
      <img class="mtn mx-2" style="cursor: pointer" src="../../assets/icons/mtn-white.svg" @click="goHome">
      <div v-if="$store.state.window >= 1100"
        :class="[$store.state.showSearch && this.lang === 'ar' ? 'right-border' : $store.state.showSearch && this.lang === 'en' ? 'left-border' : '', 'search-el-container mx-3 px-3 d-flex flex-column justify-center']">
        <div v-if="$store.state.showSearch" class="d-flex inputContainer"><img src="../../assets/icons/search-el.svg"
            @click="openSearch(0)" class="searchIcon" /><input type="text" id="myInput"
            @keypress.enter="sendSearch(searchInput)" v-model="searchInput" :placeholder="this.$t('navbar.search')"
            class="searchInput display"></div>
      </div>
    </div>
    <v-spacer></v-spacer>
    <div class="items flex-center" @click="forceClose">
      <div class="item" v-for="(item, i) in mainInfo.items" :key="i">
        <router-link :class="$store.state.activeSectionNav === i ? 'y-text' : ''"
          :to="mainInfo.paths[i]"><a>{{ item }}</a></router-link>
        <!--        <router-link to="/bundles"><a>USERS PAGE</a></router-link>-->
        <!--        <a :href="web + mainInfo.paths[i]" :class="activeItem === mainInfo.paths[i] ? 'y-text' : ''">{{item}}</a>-->
      </div>
    </div>
    <v-spacer></v-spacer>
    <div :class="[this.lang === 'ar' ? 'flex-row-reverse' : '', 'flex-center']">
      <div v-if="$store.state.window >= 1100"
        :class="[this.lang === 'ar' ? 'left-border' : 'right-border', 'lang-select-container d-flex align-items-center mx-2']">
        <img class="mx-1 world-ball" src="../../assets/icons/lang.svg">
        <div class="d-flex align-items-center'">
          <div v-click-outside="hide" @click="showUp"
            :class="[this.lang === 'ar' ? 'flex-row-reverse' : '', 'menu-container d-flex position-relative']">
            <div :class="[this.lang === 'ar' ? 'bold-ar' : 'bold-en', 'selected']">{{ selected.label }}</div>
            <div :class="[this.showMenu ? 'lang-arrow-flip' : '', 'px-1 lang-arrow']"> <img
                src="../../assets/icons/black.svg"></div>
            <div v-if="showMenu">
              <div class="menu" :style="(lang === 'ar' ? { left: '-20px' } : { left: '-30px' })">
                <div style="padding: 5px 0" :style="i === 0 ? { borderBottom: '1px solid #FFCB05' } : ''"
                  v-for="(option, i) in options" :key="i">
                  <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en']" @click="changeLan(option.value)">
                    {{ option.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$store.state.window >= 1100" class="account border-yellow-2 flex-center mx-2"
        v-on:click="reverseDialog(3)">
        <div v-if="$store.state.selectedNumber !== null">
          <a>
            <img src="../../assets/icons/account.svg">
            <span :class="[this.lang === 'ar' ? 'bold-ar' : 'bold-en', 'underline-1']" style="margin: -3px 5px 0px 5px">{{
              $store.state.selectedNumber }}</span>
            <!--            <span v-on:click.self="reverseDialog(3)" :class="[this.lang === 'ar' ? 'bold-ar' : 'bold-en','underline-1']" style="margin: -3px 5px 0px 5px">{{ $store.state.user.gsm }}</span>-->
            <img :class="[$store.state.rotate && 'rotate', 'account-arrow']"
              src="../../assets/icons/small-black-arrow.svg" />
          </a>
        </div>
        <div v-else class="w-100 h-100 flex-center">
          <img src="../../assets/icons/account.svg" v-on:click.self="reverseDialog(3)">
          <span :class="[this.lang === 'ar' ? 'bold-ar' : 'bold-en', 'underline-1']"
            style="margin: -3px 5px 0px 5px">iMTN</span>
          <img :class="[$store.state.rotate && 'rotate', 'account-arrow']"
            src="../../assets/icons/small-black-arrow.svg" />
        </div>
      </div>
      <div v-if="$store.state.window < 1100"
        :class="[this.$store.state.sidebar && this.lang === 'ar' ? 'justify-start' : this.$store.state.sidebar ? 'justify-end' : !this.$store.state.sidebar && this.lang === 'ar' ? 'flex-row-reverse justify-content-between' : 'justify-content-between', 'responsive-toggle d-flex align-items-center']">
        <div class="search-item " v-if="!$store.state.sidebar">
          <div v-if="$store.state.showSearch" class="d-flex inputContainer"><img src="../../assets/icons/search-el.svg"
              @click="openSearch(1)" class="searchIcon pointer" /><input type="text" id="myInput2"
              @keypress.enter="sendSearch(searchInput)" v-model="searchInput" :placeholder="searchPlaceholder"
              class="SmallsearchInput display"></div>
        </div>
        <div v-if="!$store.state.sidebar" @click="$store.state.sidebar = true"
          class="sidebar-toggle-container pointer mx-2"></div>
        <div v-if="$store.state.sidebar" @click="$store.state.sidebar = false">
          <img class="pointer" style="width: 45px" src="../../assets/icons/close-yellow-button.svg">
        </div>
      </div>
    </div>
    <!--    <transition v-if="$store.state.window >= 1100" name="slide-fade">-->
    <!--      <welcome-menu @close="reverseDialog(3)" v-if="dialogs[3].value"/>-->
    <!--    </transition>-->
  </div>
</template>

<script>
// import WelcomeMenu from '../Menus/WelcomeMenu'
import utils from '../../shared/utils'
// import VueSimpleSelect from 'vue-simple-custom-select'
import $ from 'jquery'
import gc from '../../utils/gc'
export default {
  name: 'SectionsNav',
  // components: { VueSimpleSelect },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      mainInfo: [],
      reverseDialog: utils.changeDialogStatus,
      dialogs: utils.dialogs,
      changeLang: utils.changeLang,
      lang: 'en',
      selected: {},
      options: [],
      web: gc.website,
      showMenu: false,
      searchOpen: false,
      searchInput: null,
      searchPlaceholder: this.$t('navbar.search')
    }
  },
  created () {
    this.mainInfo = this.data
    if (localStorage.getItem('lang') !== '') {
      this.lang = localStorage.getItem('lang')
    }
    this.options = this.lang === 'ar' ? [{ label: 'English', value: 'en' }, { label: 'العربية', value: 'ar' }] : [{ label: 'English', value: 'en' }, { label: 'العربية', value: 'ar' }]
    this.selected = this.lang === 'ar' ? { label: this.lang === 'ar' ? 'ع' : 'ع', value: 'ar' } : { label: this.lang === 'ar' ? 'en' : 'en', value: 'en' }
    this.$watch(() => {
      return this.$route.path
    }, (val) => {
      for (let i = 0; i < this.mainInfo.paths.length; i++) {
        if (val === this.mainInfo.paths[i]) {
          this.$store.state.activeSectionNav = i
        }
      }
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val < 1100) {
        this.showMenu = false
      }
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val < 460) {
        this.searchPlaceholder = this.$t('navbar.smallSearch')
      } if (val > 460) {
        this.searchPlaceholder = this.$t('navbar.search')
      }
    })
    this.$watch(() => {
      // to fetch when the value of search is empty
      return this.$store.state.searchValue
    }, (val) => {
      this.searchInput = val
    })
    window.addEventListener('resize', () => {
      this.closeSearch()
    })
  },
  mounted () {
    setTimeout(() => {
      this.lang !== 'ar' && $('.vue-simple-select-dropdown').css({
        left: 'unset', right: '0'
      })
      this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      this.lang === 'ar' ? $('.inputContainer').css('direction', 'rtl') : $('.inputContainer').css('direction', 'ltr')
      this.lang === 'ar' ? $('.searchInput').css('transform', 'translate(-60vw, 0)') : $('.searchInput').css('transform', 'translate(20vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').css('transform', 'translate(10vw, 0)') : $('.SmallsearchInput').css('transform', 'translate(-50vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').addClass('arMargin') : $('.SmallsearchInput').removeClass('arMargin')
      this.lang === 'ar' ? $('.items').css('font-family', 'Mtn-arabic-regular') && $('.items').css('flex-direction', 'row-reverse') : $('.items').css('font-family', 'Mtn-regular')
    })
  },
  destroyed () {
    window.removeEventListener('resize', () => {
      this.closeSearch()
    })
  },
  methods: {
    goHome () {
      this.closeSearch()
      this.$router.push('/home')
    },
    forceClose () {
      this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      this.lang === 'ar' ? $('.inputContainer').css('direction', 'rtl') : $('.inputContainer').css('direction', 'ltr')
      this.lang === 'ar' ? $('.searchInput').css('transform', 'translate(-60vw, 0)') : $('.searchInput').css('transform', 'translate(20vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').css('transform', 'translate(10vw, 0)') : $('.SmallsearchInput').css('transform', 'translate(-50vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').addClass('arMargin') : $('.SmallsearchInput').removeClass('arMargin')
      this.lang === 'ar' ? $('.items').css('font-family', 'Mtn-arabic-regular') && $('.items').css('flex-direction', 'row-reverse') : $('.items').css('font-family', 'Mtn-regular')
    },
    closeSearch () {
      this.forceClose()
      this.searchOpen = false
      $('.searchIcon').removeClass('searchAnimation')
      $('.items').removeClass('itemsAnimation')
      $('.searchIcon').removeClass('arsearchAnimation')
      $('.items').removeClass('aritemsAnimation')
      $('.searchInput').addClass('display')
      $('.searchIcon').removeClass('SmallsearchAnimation')
      $('.searchIcon').removeClass('arSmallsearchAnimation')
      $('.SmallsearchInput ').addClass('display')
      $('.SmallsearchInput').removeClass('arSmallsearchInput')
    },
    changeLan (val) {
      val === 'ar' ? this.changeLang(0) : this.changeLang(1)
    },
    showUp () {
      if (!this.showMenu) {
        this.showMenu = true
        setTimeout(() => {
          $('#sections_nav .menu').addClass('show')
        })
      } else {
        $('#sections_nav .menu').removeClass('show')
        setTimeout(() => {
          this.showMenu = false
        }, 300)
      }
    },
    hide () {
      $('.menu').removeClass('show')
      setTimeout(() => {
        this.showMenu = false
      }, 300)
    },
    openSearch (val) {
      if (val === 0) {
        this.searchOpen = true
        // $('.items').addClass('searchOpend')
        if (this.lang === 'en') {
          $('.searchIcon').addClass('searchAnimation')
          $('.items').addClass('itemsAnimation')
          setTimeout(() => {
            $('.searchInput').removeClass('display')
          }, 200)
        } else {
          $('.searchIcon').addClass('arsearchAnimation')
          $('.items').addClass('aritemsAnimation')
          $('.searchInput').removeClass('display')
        }
      }
      if (val === 1) {
        this.searchOpen = true
        // $('.items').addClass('searchOpend')
        if (this.lang === 'en') {
          $('.searchIcon').addClass('SmallsearchAnimation')
          // $('.items').addClass('itemsAnimation')
          setTimeout(() => {
            $('.SmallsearchInput ').removeClass('display')
          }, 400)
        } else {
          $('.searchIcon').addClass('arSmallsearchAnimation')
          // $('.items').addClass('aritemsAnimation')
          setTimeout(() => {
            $('.SmallsearchInput ').removeClass('display')
          }, 400)
          $('.SmallsearchInput').addClass('arSmallsearchInput')
        }
      }
      // $('.items').removeClass('searchOpend')
    },
    sendSearch (val) {
      this.$store.state.searchValue = val
    }
  },
  updated () {
    if (this.searchOpen === false) {
      this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      this.lang === 'ar' ? $('.inputContainer').css('direction', 'rtl') : $('.inputContainer').css('direction', 'ltr')
      this.lang === 'ar' ? $('.searchInput').css('transform', 'translate(-60vw, 0)') : $('.searchInput').css('transform', 'translate(20vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').css('transform', 'translate(10vw, 0)') : $('.SmallsearchInput').css('transform', 'translate(-50vw, 0)')
      this.lang === 'ar' ? $('.SmallsearchInput').addClass('arMargin') : $('.SmallsearchInput').removeClass('arMargin')
      this.lang === 'ar' ? $('.items').css('font-family', 'Mtn-arabic-regular') && $('.items').css('flex-direction', 'row-reverse') : $('.items').css('font-family', 'Mtn-regular')
    }
  },
  watch: {
    data (val) {
      this.mainInfo = val
    }
  }
}
</script>

<style scoped lang="scss">
.lang-arrow {
  transition: all .2s ease-in-out;
  cursor: pointer;
}

.lang-arrow-flip {
  transform: rotate(180deg);
}

@import "src/assets/sass/main";

.unClickable {
  pointer-events: none;
}

.selected {
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}

.menu {
  position: absolute;
  bottom: -57px;
  //left: -6px;
  cursor: pointer;
  background: rgba(242, 242, 242, 0.9) !important;
  font-size: 10px;
  //padding: 8px 25px;
  padding: 8px 0;
  width: 80px;
  border-radius: 8px;
  transition: all .3s ease-in-out;
  backdrop-filter: blur(50px) opacity(1);
  opacity: 0;
  padding: 0 10px;
  border: 1px solid #fff;
}

.show {
  opacity: 1;
}

.y-text {
  color: $--yellow !important;
  font-weight: bold;
}

.b-text {
  color: #1d1d1d !important;
}

.world-ball {
  width: 20px;
}

.search-item {
  margin-bottom: 3px;
  width: 24px;
  height: 24px;

  img {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 1100px) {
  .items {
    display: none !important;
  }

  .arSmallsearchInput {
    transform: translate(10vw, 0) !important;
  }
}

.search-el-container {
  height: 80%;
}

.search-el-container img {
  width: 25px;
}

.left-border {
  border-left: 1.5px solid rgba(255, 255, 255, 0.5);
}

.right-border {
  border-right: 1.5px solid rgba(255, 255, 255, 0.5);
}

.lang-select-container {
  height: 80%;
  align-self: center;
  padding: 0 10px;
}

.responsive-toggle {
  width: 95px;
}

.sidebar-toggle-container {
  width: 35px;
  height: 12px;
  cursor: pointer;
  border-top: 4px solid #FFCB05;
  border-bottom: 4px solid #FFCB05;
}

.searchOpend {
  display: none;
}

.searchIcon {
  transition: transform ease 500ms;
  cursor: pointer;
}

.items {
  transition: transform ease 500ms;
}

.searchAnimation {
  transform: translate(20vw, 0);
}

.SmallsearchAnimation {
  transform: translate(-50vw, 0);
}

.itemsAnimation {
  transform: translate(100vw, 0);
}

.arsearchAnimation {
  transform: translate(-20vw, 0);
}

.aritemsAnimation {
  transform: translate(-100vw, 0);
}

.searchInput {
  transform: translate(20vw, 0);
}

.SmallsearchInput {
  transform: translate(-50vw, 0);
}

.arSmallsearchAnimation {
  transform: translate(50vw, 0);
}

.display {
  display: none;
  /*opacity: 0;*/
}

.searchInput {
  /*opacity: 1;*/
  transition: display ease 500ms;
  width: 35vw;
  margin-right: -40vw;
  padding: 0 30px;
}

.SmallsearchInput {
  /*opacity: 1;*/
  transition: display ease 1500ms;
  width: 36vw;
  margin-right: -40vw;
  padding: 0 15px;
}

@media screen and (max-width: 590px) {
  .SmallsearchInput {
    width: 53vw;
    margin-right: -51vw;
  }

  .arMargin {
    margin-right: -42vw;
  }
}

@media screen and (max-width: 360px) {

  .SmallsearchInput,
  .searchIcon {
    display: none;
  }
}

@media screen and (max-width: 780px) {
  .SmallsearchInput {
    width: 45vw;
    margin-right: -50vw;
  }

  .arSmallsearchInput {
    transform: translate(0vw, 0) !important;
  }
}

@media screen and (max-width: 610px) {
  .SmallsearchInput {
    width: 58vw;
    margin-right: -55vw;
  }

  .SmallsearchInput,
  .SmallsearchAnimation {
    transform: translate(-55vw, 0px) !important;
  }

  .arSmallsearchInput {
    transform: translate(-4vw, 0) !important;
  }
}

@media screen and (max-width: 570px) {
  .arSmallsearchInput {
    transform: translate(-5vw, 0) !important;
  }
}

@media screen and (max-width: 500px) {

  .SmallsearchInput,
  .SmallsearchAnimation[data-v-a69965b4] {
    transform: translate(-51vw, 0px);
  }

  .arSmallsearchInput {
    transform: translate(-5vw, 0) !important;
  }
}

@media screen and (max-width: 450px) {
  .SmallsearchInput {
    width: 50vw;
    margin-right: -55vw;
  }

  .SmallsearchInput,
  .SmallsearchAnimation {
    transform: translate(-42vw, 0px) !important;
  }

  .arSmallsearchAnimation {
    transform: translate(43vw, 0px) !important;
  }

  .arSmallsearchInput {
    transform: translate(-12vw, 0) !important;
  }
}</style>
<style lang="scss">
